import { useState, useRef, useEffect } from "react";
import { ShieldAlert } from "lucide-react";
import { useNotifications } from "../hooks/useNotifications";

function fmtRelative(iso) {
  const mins = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export default function NotificationBell({ onSelect }) {
  const { notifications, unreadCount, markRead, markAllRead } = useNotifications(true);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onClickOutside(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  function handleClickItem(n) {
    if (!n.isRead) markRead(n.id);
    setOpen(false);
    onSelect?.(n);
  }

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button
        onClick={() => setOpen(o => !o)}
        title="Fleet Alerts"
        style={{
          position: "relative", display: "flex", alignItems: "center", justifyContent: "center",
          background: "none", border: "1px solid #E5E7EB", borderRadius: 8,
          width: 36, height: 36, cursor: "pointer", color: "#6B7280",
        }}
      >
        <ShieldAlert size={15} />
        {unreadCount > 0 && (
          <span style={{
            position: "absolute", top: -4, right: -4,
            background: "#DC2626", color: "#fff", fontSize: 10, fontWeight: 700,
            borderRadius: 99, minWidth: 16, height: 16, padding: "0 4px",
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "2px solid #fff",
          }}>
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </button>

      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 8px)", right: 0, zIndex: 950,
          width: 340, maxHeight: 420, overflow: "auto",
          background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12,
          boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
        }}>
          <div style={{
            padding: "12px 16px", borderBottom: "1px solid #F3F4F6",
            display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <span style={{ fontSize: 13.5, fontWeight: 700, color: "#111827" }}>Fleet Alerts</span>
            {unreadCount > 0 && (
              <button
                onClick={markAllRead}
                style={{ background: "none", border: "none", color: "#4F46E5", fontSize: 12, fontWeight: 600, cursor: "pointer" }}
              >
                Mark all read
              </button>
            )}
          </div>

          {notifications.length === 0 ? (
            <div style={{ padding: "32px 16px", textAlign: "center", fontSize: 13, color: "#9CA3AF" }}>
              No notifications
            </div>
          ) : (
            notifications.map(n => (
              <div
                key={n.id}
                onClick={() => handleClickItem(n)}
                style={{
                  padding: "12px 16px", borderBottom: "1px solid #F3F4F6", cursor: "pointer",
                  background: n.isRead ? "#fff" : "#EEF2FF",
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                  {!n.isRead && (
                    <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#4F46E5", marginTop: 5, flexShrink: 0 }} />
                  )}
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: "#111827" }}>{n.title}</div>
                    <div style={{ fontSize: 12, color: "#6B7280", marginTop: 2 }}>{n.message}</div>
                    <div style={{ fontSize: 11, color: "#9CA3AF", marginTop: 4 }}>{fmtRelative(n.createdAt)}</div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}
